<template>
    <PageLayout title="List Device">
        <template #actions>
            <a
                v-on:click="toggleModal('new_device')"
                class="btn px-15 btn-primary text-white"
            >
                <i class="fas fa-plus fs-16"></i>
                Tambah Device
            </a>
        </template>

        <template #alert>
            <div v-if="deviceQuota == -1" class="alert alert-success" role="alert">
                <div class="alert-content">
                    <p>Batas device maksimal anda adalah <b>Unlimited</b> device</p>
                </div>
            </div>
            <div v-else-if="deviceQuota == 0" class="alert alert-danger" role="alert">
                <div class="alert-content">
                    <p>Batas device maksimal anda adalah <b>{{ deviceQuota }}</b> device</p>
                </div>
            </div>
            <div v-else class="alert alert-primary" role="alert">
                <div class="alert-content">
                    <p>Batas device maksimal anda adalah <b>{{ deviceQuota }}</b> device</p>
                </div>
            </div>
        </template>

        <ContentCard>
            <GroupTable />
        </ContentCard>

        <modal name="new_device" :height="'auto'" :adaptive="true" :scrollable="true">
            <div class="modal-body-padding">
                <AddDevice />
            </div>
        </modal>
    </PageLayout>
</template>

<script>
    import GroupTable from "@/components/tables/Device.vue";
    import AddDevice from "@/components/forms/device/Add.vue";

    export default {
        components: {
            GroupTable,
            AddDevice,
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: [],
                deviceQuota: 0
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.deviceQuota = this.$store.state.auth.user.max_device
        },
        methods: {
            toggleModal(param) {
                this.$modal.toggle(param);
            }
        },
    };
</script>
